import { Box, styled, Typography, useTheme } from "@mui/material";
import { style, SxProps } from "@mui/system";
import TextConfirmButton from "../../../../components/AppButtons/TextConfirmButton";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../../configuration/themeSettings";
import { AppIconsArrow } from "../../../../components/AppIcons";


export const useClasses = () => {

    const theme = useTheme();
    const classes = {
    }
    return classes;

};

export const TextConfirmButtonStyled = styled(TextConfirmButton, { label: "filtersearch-content" })(({ theme }) => ({

    '& .MuiButton-label': {
        width: "auto",
        minWidth: "110px",
        maxWidth: "200px",
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
    },

}));



export const StyleArrowIcon = styled(AppIconsArrow, {
    label: "filtersearch-content_styled-machine-selected_arrow",
})(({ theme }) => ({
    fontSize: 15,
    cursor: "pointer"
}));

export const StyledBoxMachineSelected = styled("div", {
    label: "filtersearch-content_styled-machine-selected",
})(({ theme }) => ({
    display: "flex",
    fontSize: "14px",
    flexDirection: "column",
    textAlign: "left",
    /* padding-left: 15px; */
    borderBottom: "1px solid black",
    marginLeft: "20px",
    paddingTop: "0px",
    lineHeight: "20px",
    width: "350px",
}));

export const StyledBoxSortOrderSelected = styled("div", {
    label: "filtersearch-content_styled-sortorder-selected",
})(({ theme }) => ({
    display: "flex",
    fontSize: "14px",
    flexDirection: "column",
    textAlign: "left",
    /* padding-left: 15px; */
    borderBottom: "1px solid black",
    //marginLeft: "20px",
    paddingTop: "0px",
    lineHeight: "20px",
    width: "350px",
}));
;
;
export const ContentStyled = styled("div", { label: "filtersearch-content_styled" })(
    ({ theme }) => ({
        width: 300,
        marginRight: 10,
        maxWidth: "350px",
        "&:last-child": {
            marginRight: 0,
        }, 
        "> :first-of-type": {
            marginTop: 0,
        },
        'svg':{
            color: StyleguideSavioColors.mainBlue,
        }
    })
);

export const ButtonsGroup = styled("div", { label: "filtersearch-button_group" })(({ theme }) => ({
    display: 'flex',
    alignItems: "flex-end",
    justifyContent: "right",
    paddingBottom: 2,
    "> button": {
        marginRight: 10,
        "&:last-child": {
            marginRight: 0,
        }
    }
}));

export const GroupContentStyled = styled("div", { label: "filtersearch-group_content_styled" })(({ theme }) => ({
    display: 'flex',
}));

export const SubContainerStyled = styled("div", { label: "filtersearch-subcontainer" })(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between"
}));

export const BoxContainerStyled = styled(Box, { label: "filtersearch-container" })(({ theme }) => ({
    padding: theme.spacing(0, 1, 1, 1),
    width: "100%",
    boxSizing: 'border-box',
}));

export const LabelStyled = styled(Typography, { label: "filtersearch-label_styled" })(
    ({ theme }) => ({
        fontSize: 14,
        fontWeight: StyleguideSavioFonts.bold,
        color: StyleguideSavioColors.mainBlue,
        textTransform: "uppercase",
        textAlign: "left",
        paddingLeft: 0,
        marginTop: "17px",
        marginLeft: 0,
        marginBottom: "15px",

    })
);